module.exports = __webpack_public_path__ + "static/media/chevron-left-grey.200da9d7.svg";